import api from './api'
import { 
  mockProducts, 
  mockCategories, 
  getProductById, 
  getFeaturedProducts, 
  getProductsByCategory, 
  searchProducts, 
  filterProducts 
} from '../data/mockProducts'

// Flag to use mock data (set to true for development without backend)
const USE_MOCK_DATA = true

export const productService = {
  // Get all products with optional filters
  getProducts: async (params = {}) => {
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 500))
      return filterProducts(params)
    }
    
    const response = await api.get('/products', { params })
    return response.data
  },

  // Get single product by ID
  getProduct: async (id) => {
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 300))
      const product = getProductById(id)
      if (!product) {
        throw new Error('Product not found')
      }
      return product
    }
    
    const response = await api.get(`/products/${id}`)
    return response.data
  },

  // Get product categories
  getCategories: async () => {
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 200))
      return mockCategories
    }
    
    const response = await api.get('/products/categories')
    return response.data
  },

  // Get featured products
  getFeaturedProducts: async () => {
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 400))
      return getFeaturedProducts()
    }
    
    const response = await api.get('/products/featured')
    return response.data
  },

  // Get products by category
  getProductsByCategory: async (category) => {
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 300))
      return getProductsByCategory(category)
    }
    
    const response = await api.get(`/products/category/${category}`)
    return response.data
  },

  // Search products
  searchProducts: async (query) => {
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 400))
      return searchProducts(query)
    }
    
    const response = await api.get(`/products/search?q=${encodeURIComponent(query)}`)
    return response.data
  },
}